import PropTypes from 'prop-types';
import React from 'react';
import { useForm, Controller } from 'react-hook-form';

import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  Button, DialogActions, DialogContent, TextField
} from '@mui/material';

import { translate } from 'utils/helpers';
import { ModalHeader } from './ModalHeader';

export const DeleteBottleModal = ({
                                    onClose, onConfirm, closeOnSubmit
                                  }) => {
  const { control, handleSubmit } = useForm({
    defaultValues: {
      comment: ''
    }
  });
  const onSubmit = (data) => {
    onConfirm({
      ...data
    });

    if (closeOnSubmit) {
      onClose();
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ModalHeader className="warningModal" onClose={onClose}>
        <FontAwesomeIcon icon={faExclamationTriangle} />
        {translate('modalDeleteBottle.deleteBottle')}
      </ModalHeader>

      <DialogContent style={{ paddingTop: '10px' }}>
        <Controller
              control={control}
              name="comment"
              render={({ field }) => (
                <TextField
                      {...field}
                      label={translate('common.comment')}
                      multiline
                      required
                      rows={3}
                      style={{ width: '100%' }}
                  />
              )}
              rules={{ required: true }}
          />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>{translate('button.cancel')}</Button>
        <Button color="primary" id="deleteBottleConfirm" type="submit">{translate('button.validate')}</Button>
      </DialogActions>
    </form>
  );
};

DeleteBottleModal.propTypes = {
  closeOnSubmit: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired
};

DeleteBottleModal.defaultProps = {
  closeOnSubmit: true
};
